import { ActionTypes } from './types';
import { ThunkResult } from '../../types';

export const matchingAnswersAreSelected = (answers: any, questionId: string): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.QUESTION_MATCHING_ANSWERS_ARE_SELECTED,
    payload: { answers, questionId }
  });
};
